import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { PlRequestOrderTypeStrategyImpl } from "../model/impl/PlRequestOrderTypeStrategyImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class PlRequestOrderTypeStrategyImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: PlRequestOrderTypeStrategyImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(1),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.description != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(2),
        false,
        encodable.description,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.isCreditCheckAllowedFg != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(3),
        false,
        encodable.isCreditCheckAllowedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.isMarkupAllowedFg != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(4),
        false,
        encodable.isMarkupAllowedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.isSTPAggregatedFg != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(5),
        false,
        encodable.isSTPAggregatedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.isSTPAggPartFillsFg != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(6),
        false,
        encodable.isSTPAggPartFillsFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "com.bcdfx.model.RequestOrderType"],
    [2, "java.lang.String"],
    [3, "java.lang.Boolean"],
    [4, "java.lang.Boolean"],
    [5, "java.lang.Boolean"],
    [6, "java.lang.Boolean"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: PlRequestOrderTypeStrategyImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.RequestOrderType = this.baseEncoder.readObject(
            false,
            false,
            PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.id = <CubiqTS.RequestOrderType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.description = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.isCreditCheckAllowedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.isMarkupAllowedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.isSTPAggregatedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.isSTPAggPartFillsFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return PlRequestOrderTypeStrategyImplEncoder.fidTypeMap.has(fid);
  }
}
